// molecules/CartIcon.jsx
import React from 'react';
import styled from '@emotion/styled';
import { useCart } from 'context/CartContext';
import { ShoppingCart } from 'lucide-react';

const CartIconWrapper = styled.button`
  position: relative;
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ isScrolled, theme }) =>
    isScrolled ? theme.colors.primary : theme.colors.white};
  transition: color 0.3s ease;

  ${({ theme }) => theme.mediaQueries.sm} {
    &:hover {
      color: ${({ theme }) => theme.colors.primary};
    }
  }
`;

const CartCount = styled.span`
  position: absolute;
  top: 0;
  right: 0;
  background-color: ${({ theme }) => theme.colors.primary};
  color: white;
  border-radius: 50%;
  min-width: 18px;
  height: 18px;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 4px;
  font-weight: bold;
`;

const CartIcon = ({ onClick, isScrolled }) => {
  const { getTotalItems } = useCart();

  // Calculate total items in cart using the new structure
  const itemsCount = getTotalItems();

  return (
    <CartIconWrapper
      onClick={onClick}
      isScrolled={isScrolled}
      aria-label="Open cart"
    >
      <ShoppingCart size={24} />
      {itemsCount > 0 && <CartCount>{itemsCount}</CartCount>}
    </CartIconWrapper>
  );
};

export default CartIcon;
